export const environment = {
  production: false,
  local: false,
  apiUrl: 'https://test-api.mojob.io/api/v2.7/',
  intercomAppId: 'hg3c1fr1',
  baseURL: '',
  appUrl: 'https://test-app.mojob.io/',
  applicant_app_url: 'http://test-applicant.mojob.io',
  blog_url: 'https://test-blog.mojob.io/',

  googleAnalyticsTrackingId: 'UA-116823330-1',

  stripeAPIKey: 'pk_test_LiyHBC0Se59KKkGyAhjCW9ka',

  jobShareUrl: 'https://test-job.mojob.io/',
  chat_websocket_url: 'wss://test-websocket.mojob.io/chat/stream/',
  notification_stream_websocket_url:
    'wss://test-websocket.mojob.io/notification/stream/',

  hotjarId: 1038489,
  hotjarVersion: 6,
  google_maps_api_key: 'AIzaSyAtSEdoe9e2tAWn-Z0nCg5cHSskQHjMfx8',

  finnProductId: 4,
  autosaveIntervalInMs: 36000,
};
